import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-equipment-details',
  templateUrl: 'equipment-details.html',
})
export class EquipmentDetailsPage {
  eq: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.eq = navParams.data['equipment'];
  }

  close() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/equipment-details/equipment-details.ts